<template>
  <section>
    <div class="main__content">
      <bar-loader
        class="loadingBar"
        :loading="isLoading"
        :color="'#ffffff'"
        :size="100"
        :width="150"
      />
      <pd-main v-if="!isLoading" :pokemon="pokemon" />
    </div>
  </section>
</template>

<script>
import PdMain from '@/components/PdMain'
import api from '@/api'

export default {
  name: 'Home',
  components: { PdMain },
  data() {
    return {
      isLoading: false,
      pokemon: { name: '', url: '' },
    }
  },

  updated() {
    this.ruta = this.$route
    this.$emit('homeActived', this.ruta.name)
  },

  created() {
    this.isLoading = true
    document.title = 'PokeDex'
    api
      .getImage()
      .then((character) => {
        try {
          this.pokemon.name = character[0]
          this.pokemon.url = character[1]
        } catch (error) {
          console.log(error)
        }
      })
      .finally(() => (this.isLoading = false))
  },
}
</script>

<style scoped>
@import '../styles/home.css';
</style>
